import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'Pagina betg chattada',
  title: 'Nus n\'avain betg chattà questa pagina',
  body: 'La colliaziun è forsa antiquada, u la pagina è vegnida allontanada. Ditgai a nus tge che Vus tschertgais, e nus chattain quai per Vus.',
  suggestionsTitle: 'Forsa tschertgais Vus',
  bestMatchTitle: 'Manegiavas Vus',
  prefillHint: 'Emplenì ordavant tenor l\'adressa che Vus avais empruvà',
  goHome: 'Pagina iniziala',
  browseAll: 'Tut las categorias',
  reportBrokenLink: 'Annunziar ina colliaziun defecta',
  noticeTitle: 'Questa pagina n\'è betg disponibla',
  noticeSearching: 'Nus tschertgain empè quai {query}…',
  noticePrefilled: 'Tschertgai {query} sutvart, u ditgai a nus tge che Vus tschertgais.',
  errorTitle: 'Insatge è ì storta',
  errorBody: 'Nus n\'avain betg pudì chargiar questa pagina. Empruvai anc ina giada, u tschertgai sutvart quai che Vus duvrais.',
  retry: 'Empruvar anc ina giada',
  streamLostTitle: 'Nus n\'avain betg pudì terminar questa pagina',
  streamLostBody: 'La tschertga è sa fermada avant che la pagina saja vegnida memorisada. Aviai la tschertga anc ina giada, e nus cumenzain da nov cun Voss pleds.',
  relaunch: 'Tschertgar danovamain',
};
